export const mockContacts = [
  { id: "c1", name: "John Martin", phone: "+46 70 123 4501", initials: "JM", color: "#FDE68A" },
  { id: "c2", name: "Anna Lindqvist", phone: "+46 70 123 4502", initials: "AL", color: "#BFDBFE" },
  { id: "c3", name: "Marco Rossi", phone: "+39 333 555 0103", initials: "MR", color: "#FBCFE8" },
  { id: "c4", name: "Sofia Andersson", phone: "+46 70 123 4504", initials: "SA", color: "#BBF7D0" },
  { id: "c5", name: "David Chen", phone: "+44 7700 900105", initials: "DC", color: "#DDD6FE" },
  { id: "c6", name: "Elena Petrova", phone: "+48 500 600 106", initials: "EP", color: "#FED7AA" },
  { id: "c7", name: "Liam O'Connor", phone: "+353 83 123 4107", initials: "LO", color: "#A7F3D0" },
  { id: "c8", name: "Yuki Tanaka", phone: "+81 90 1234 5108", initials: "YT", color: "#FBCFE8" },
];

export const PARTNER = {
  name: "Finshark",
  method: "Bank Transfer",
  license: "Licensed PSP — EU / EEA",
};
